module.exports = __webpack_public_path__ + "static/media/05.Akad.Program.1ec89d6c.JPG";